export var SurveyInvitationChannel;
(function (SurveyInvitationChannel) {
    SurveyInvitationChannel["LINK"] = "LINK";
    SurveyInvitationChannel["EMAIL"] = "EMAIL";
})(SurveyInvitationChannel || (SurveyInvitationChannel = {}));
export var SurveyInvitationStatus;
(function (SurveyInvitationStatus) {
    SurveyInvitationStatus["NOT_OPENED"] = "NOT_OPENED";
    SurveyInvitationStatus["OPENED"] = "OPENED";
    SurveyInvitationStatus["IN_PROGRESS"] = "IN_PROGRESS";
    SurveyInvitationStatus["COMPLETED"] = "COMPLETED";
    SurveyInvitationStatus["VOIDED"] = "VOIDED";
})(SurveyInvitationStatus || (SurveyInvitationStatus = {}));
